import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";

const HEADER_CONTENT_HORIZONTAL_PADDING = `${Constants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;

export const componentStyles = css`
  .side-by-side-paragraph-and-products-tabs-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;
    padding: ${`0 ${HEADER_CONTENT_HORIZONTAL_PADDING}`};
    display: flex;
    justify-content: space-between;

    :global(.signup-button-wrapper) {
      align-items: flex-start;
    }

    :global(.products-tabs) {
      min-width: 436px;
    }
  }
`;
